import validate from "/workspace/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45device_45verification_45global from "/workspace/app/middleware/check-device-verification.global.ts";
import manifest_45route_45rule from "/workspace/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45device_45verification_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "assembly-edit-with-cart": () => import("/workspace/app/middleware/assembly-edit-with-cart.ts"),
  "checkout-step": () => import("/workspace/app/middleware/checkout-step.ts"),
  "previous-route": () => import("/workspace/app/middleware/previousRoute.ts"),
  "re-captcha": () => import("/workspace/app/middleware/re-captcha.ts")
}